import { render, staticRenderFns } from "./WorkOrderList.vue?vue&type=template&id=712ed5ce&"
import script from "./WorkOrderList.vue?vue&type=script&lang=js&"
export * from "./WorkOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports